module.exports = __webpack_public_path__ + "static/media/champagne.995b2254.svg";